import React, {memo} from 'react';
import {NavHeader as NavHeaderComponent} from '@unthinkable/react-screen-components';
import {useStyles} from '@unthinkable/react-theme';
import {Image, Row, View} from '@unthinkable/react-core-components';
import {navHeaderStyles} from './theme';
import {useNavigation, useNavigationState} from '@react-navigation/native';
import {UserProfile} from '../../app-components/renders/user/UserProfile';
import {useAppStateContext} from '../../providers/AppState';
import {Breadcrumb} from './AppBreadcrumbs';

const NavFixedHeaderActions = props => {
  const {
    route: {params},
  } = props;

  let fixedActions = [];

  fixedActions.push(<UserProfile {...props} />);

  return (
    <Row style={{alignItems: 'center'}} gap={8}>
      {fixedActions}
    </Row>
  );
};

const NavHeaderActions = ({actions = [], ...props}) => {
  const {styles} = props;
  const {actionSeparator} = styles || {};
  if (actions && !Array.isArray(actions)) {
    actions = [actions];
  }

  return (
    <Row gap={24}>
      {actions?.length ? (
        <Row gap={16} style={{alignItems: 'center'}}>
          {actions}
        </Row>
      ) : (
        void 0
      )}
      <View style={actionSeparator}></View>
      <NavFixedHeaderActions {...props} />
    </Row>
  );
};

export const CustomNavHeader = ({back, title, actions, ...props}) => {
  const {route: {params} = {}} = props;
  const navigation = useNavigation();
  const state = useNavigationState(state => state);
  const {navigationType} = useAppStateContext();

  const onBack = () => {
    navigation?.goBack?.();
  };

  if (navigation?.canGoBack?.()) {
    const prevRoute = state?.routes[state.index - 1];
    back = back || {title: prevRoute?.name};
    title = title || back?.title;
  }

  const actionsComponent = <NavHeaderActions actions={actions} {...props} />;

  return (
    <NavHeaderComponent
      {...props}
      title={title}
      back={params?.breadcrumb ? void 0 : back}
      onBack={onBack}
      skipLogo={navigationType === 'new'}
      actions={actionsComponent}>
      {props?.route?.params?.breadcrumb ? <Breadcrumb {...props} /> : void 0}
    </NavHeaderComponent>
  );
};

export const NavHeader = memo(({...props}) => {
  const styles = useStyles(navHeaderStyles);
  return <CustomNavHeader {...props} styles={styles} />;
});
